/* eslint-disable func-names */
import striptags from 'striptags'
import { reIndexResponses } from '../../helpers'

const allowedTags = [
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'b',
  'strong',
  'i',
  'em',
  'mark',
  'small',
  'del',
  'ins',
  'sub',
  'sup',
  'table',
  'tr',
  'thead',
  'tbody',
  'th',
  'td',
  'tfoot',
  'img',
  'ul',
  'ol',
  'dl',
  'li',
  'p',
  'br',
  'a',
  'audio',
  'video',
  'source',
]

function customPastePlugin(FroalaEditor) {
  FroalaEditor.DEFAULTS = Object.assign(FroalaEditor.DEFAULTS, {
    sanitizeClipboardHtml: false,
  })

  FroalaEditor.PLUGINS.customPastePlugin = function (editor) {
    function cleanup(clipboard_html) {
      let sanitizedString = clipboard_html
      // If disableHTMLPaste is true, strip all HTML and return plain text
      if (editor.opts.disableHTMLPaste) {
        // Create a temporary div to extract plain text
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = clipboard_html
        sanitizedString = tempDiv.textContent || tempDiv.innerText || ''
        return sanitizedString
      }

      if (editor.opts.sanitizeClipboardHtml) {
        sanitizedString = sanitizedString
          ?.replace(/<meta[\s\S]*?>/g, '')
          ?.replace(/(<p(.*?)>)/g, '<p>')
      }

      if (editor.opts.restrictTags) {
        sanitizedString = striptags(sanitizedString, allowedTags)
      }

      // Remove tags with classname fr-sr-only using jQuery
      if (sanitizedString) {
        try {
          const tempDiv = $('<div>').html(sanitizedString)
          tempDiv.find('.fr-sr-only').remove()
          sanitizedString = tempDiv.html()
        } catch (error) {
          console.warn('Error removing fr-sr-only tags:', error)
        }
      }

      // Strip overflow: hidden properties from pasted content to prevent dropdown clipping (EV-46695)
      if (sanitizedString) {
        try {
          const tempDiv = $('<div>').html(sanitizedString)
          // Find all elements with overflow: hidden and remove this specific style
          tempDiv.find('*').each(function () {
            const $element = $(this)
            // Check if element has overflow properties set to 'hidden' and remove them
            if ($element.css('overflow') === 'hidden') {
              $element.css('overflow', '')
            }
            if ($element.css('overflow-x') === 'hidden') {
              $element.css('overflow-x', '')
            }
            if ($element.css('overflow-y') === 'hidden') {
              $element.css('overflow-y', '')
            }
          })
          sanitizedString = tempDiv.html()
        } catch (error) {
          console.warn('Error removing overflow:hidden properties:', error)
        }
      }

      return sanitizedString
    }

    function updateHtml() {
      this.selection.save()
      const updatedHtml = reIndexResponses(this.html.get(true))
      if (updatedHtml) {
        this.html.set(updatedHtml)
      }
    }

    function _init() {
      editor.events.on('paste.beforeCleanup', cleanup)
      editor.events.on('paste.afterCleanup', cleanup)
      editor.events.on('paste.after', updateHtml)
    }
    return {
      _init,
    }
  }
}

export default customPastePlugin
